export enum LOGIN_TYPES {
  DEFAULT='DEFAULT',
  SSO='SSO'
}
